// extracted by mini-css-extract-plugin
export default {"container":"L2-z","heading":"M2-z","links":"N2-z","copy":"O2-z","subCopy":"P2-z","linksLeft":"Q2-z","linksCenter":"R2-z","linksRight":"S2-z","link":"T2-z","onlyLink":"U2-z"};